import { useState } from "react";
import { Link } from "react-router-dom";
import { Music2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("If that email exists, we sent a reset link.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory grid place-items-center p-4">
      <div className="w-full max-w-md card-base p-6 sm:p-8 animate-fade-up" data-testid="forgot-card">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <span className="w-9 h-9 rounded-xl bg-sage-500 text-white grid place-items-center"><Music2 size={20} /></span>
          <span className="font-heading font-semibold text-lg">AMDS</span>
        </Link>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Reset your password</h1>
        <p className="text-ink-600 text-sm mt-1">Enter your email and we'll send you a reset link.</p>
        {done ? (
          <div className="mt-6 p-4 rounded-xl bg-sage-100 text-sage-700 text-sm" data-testid="forgot-done">
            Check your inbox. The link is valid for one hour.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" placeholder="you@example.com" data-testid="forgot-email-input" />
            <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="forgot-submit-btn">{busy ? "Sending…" : "Send reset link"}</button>
          </form>
        )}
        <div className="mt-6 text-sm">
          <Link to="/login" className="text-sage-600 hover:text-sage-700" data-testid="forgot-back-link">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
